import React, { useState } from 'react';
import { faqData } from '../assets/dummyData/faq';
import { NewsLetterContentFaq } from '../assets/dummyData/NewsLetterData';
import Faq from '../components/Faq/Faq';
import Helmet from '../components/Helmet';
import NewLetter from '../components/NewLetter/NewLetter';
import ModalEmailSuccess from '../components/ModalEmailSuccess/ModalEmailSuccess';

const FaqPage = () => {
  const [shoeModalEmail, setShoeModalEmail] = useState(false);
  const lang = "en";
  const modalEmail = () => {
    setShoeModalEmail(true);
    const body = document.body;
    body.classList.add("modal-open");
    setTimeout(() => {
        setShoeModalEmail(false);
    }, 500);
  }
  
  return (
    <div id="page-faq" className="page">
        <Helmet
          title="Faq | Captain Candy"
          metaDesc="At Captain Candy we offer the best quality candies. You will find delicious jellies, selected chocolates, great licorice candies, marshmallows, but also chewing gum and lollipops. Everyone really chooses."
        />
        <Faq data={faqData[lang]} title={faqData?.title[lang]} />
        <NewLetter hiddeImg data={NewsLetterContentFaq[lang]} openModal={modalEmail} />
        <ModalEmailSuccess open={shoeModalEmail} />
    </div>
  )
}

export default FaqPage;